export default __webpack_public_path__ + "static/media/cr4.34ffb1a6.jpg";